import { render, staticRenderFns } from "./capecList.vue?vue&type=template&id=e9fb71c4&scoped=true&"
import script from "./capecList.vue?vue&type=script&lang=js&"
export * from "./capecList.vue?vue&type=script&lang=js&"
import style0 from "./capecList.vue?vue&type=style&index=0&id=e9fb71c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fb71c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VIcon,VRow,VTextField})
